<div class="container flex column fill-width">
  <div class="flex row slider">
    <input
      class="flex fill-width"
      type="range"
      min="{{ minMs }}"
      max="{{ maxMs }}"
      value="{{ valueMs }}"
      (change)="onChange($event)"
    />
  </div>
  <div class="flex row preview space-between">
    <div class="flex column time-preview start">
      {{ minMs / 1000 | duration }}
    </div>
    <div
      class="flex column time-preview middle"
      *ngFor="let previewStep of previewStepsArray; let index = index"
    >
      {{
        (((index + 1) / (1 + previewStepsBetween)) * maxMs) / 1000 | duration
      }}
    </div>
    <div class="flex column time-preview end">
      {{ maxMs / 1000 | duration }}
    </div>
  </div>
</div>
